import './barcode-reader-toggle.scss'

import { faBarcode } from '@fortawesome/free-solid-svg-icons';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { BarcodeSubscriber } from '@skinsoft/ui';
import { Component } from 'vue-property-decorator';

import { TURN_OFF_BARCODE_READER_TOPIC, TURN_ON_BARCODE_READER_TOPIC } from '../../../../busTopics';

@Component({
    components: {
        sBarcodeSubscriber: BarcodeSubscriber,
    },
    props: ['completelyDisabled'],
    template: require('./barcode-reader-toggle.html'),
})
export class BarcodeReaderToggle extends ReactiveVue {
    public completelyDisabled: boolean;

    public barcodeIcon = faBarcode;

    public enabled: boolean = false;

    public created() {
        this.subscribeToBus(TURN_OFF_BARCODE_READER_TOPIC, () => {
            this.enabled = false;
        });
        this.subscribeToBus(TURN_ON_BARCODE_READER_TOPIC, () => {
            this.enabled = true;
        });
    }

    public toggle() {
        this.enabled = !this.enabled;
    }
}
